class Overlap2Col {
    constructor(element) {
        this.element = element;
        this.scrollHeight = 0;

        const buttons = element?.parentNode?.querySelector('.overlap-2col-float__expand-btns');
        this.moreBtn = buttons?.querySelector('.btn[data-action="more"]');
        this.lessBtn = buttons?.querySelector('.btn[data-action="less"]');

        this.attachEventListeners();
        this.handleResize(); // initial check
        window.addEventListener('resize', this.handleResize);
    }

    attachEventListeners = () => {
        this.moreBtn?.addEventListener('click', this.slideDown);
        this.lessBtn?.addEventListener('click', this.slideUp);
    }

    handleResize = () => {
        const width = window.innerWidth;

        // If wider than 768px, reset height and remove truncation/expansion
        if (width > 768) {
            this.element.style.removeProperty('height');
            this.element.classList.remove('overlap-2col-float__base--truncated');
            this.element.classList.remove('overlap-2col-float__base--expanded');
            return;
        }

        // Else, do truncation check
        this.scrollHeight = this.element.scrollHeight;
        this.updateTruncation();
    }

    updateTruncation = () => {
        const isOverflowing = this.element.scrollHeight > this.element.clientHeight;
        this.element.classList.toggle('overlap-2col-float__base--truncated', isOverflowing);
    }

    slideUp = () => {
        this.element.style.removeProperty('height');
        this.element.classList.add('overlap-2col-float__base--truncated');
        this.element.classList.remove('overlap-2col-float__base--expanded');
    }

    slideDown = () => {
        this.scrollHeight = this.element.scrollHeight;
        this.element.classList.add('overlap-2col-float__base--expanded');
        this.element.classList.remove('overlap-2col-float__base--truncated');
        this.element.style.height = `${this.scrollHeight}px`;
    }

    disconnect = () => {
        window.removeEventListener('resize', this.handleResize);
    }
}

export default Overlap2Col;
